import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHashtag = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.33366 2.5L6.66699 17.5M13.3337 2.5L11.667 17.5M2.50033 7.5H17.5003M1.66699 12.5H16.667",
		stroke: "#EFEEF0",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgHashtag;
